import { render, staticRenderFns } from "./AddUserIcon.vue?vue&type=template&id=0869d4e1"
import script from "./AddUserIcon.vue?vue&type=script&lang=ts"
export * from "./AddUserIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports